import { Api } from '../api';
import { dashboard } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  DashboardItemsRequest,
  DashboardSummariesResponse,
  ExpenseCategory,
  Merchant,
  Notification,
  NotificationDetailedResponse,
  PaymentSummariesRequest,
  PaymentSummariesResponse,
  Spending,
  Summary,
  UpdateNotificationRequest,
} from './models';

export class DashboardApi extends Api {
  static getAccountSummary = (signal?: AbortSignal) =>
    this.get<ApiPaginate<DashboardSummariesResponse[]>>({ url: dashboard.accountSummary(), signal });

  static getNotifications = (signal?: AbortSignal) => this.get<ApiResponse<Notification[]>>({ url: dashboard.notifications(), signal });

  static updateNotifications = (request: UpdateNotificationRequest, signal?: AbortSignal) =>
    this.put<UpdateNotificationRequest, ApiResponse<Notification[]>>({ url: dashboard.notifications(), signal, data: request });

  static getNotificationByAlert = (alertGuid: string) =>
    this.get<ApiResponse<NotificationDetailedResponse>>({ url: dashboard.notificationDetail(alertGuid) });

  static deleteNotification = (request: UpdateNotificationRequest, signal?: AbortSignal) =>
    this.delete<UpdateNotificationRequest, ApiResponse<Notification[]>>({ url: dashboard.notifications(), queryParams: request, signal });

  static getSummaries = (signal?: AbortSignal) => this.get<ApiResponse<Summary[]>>({ url: dashboard.summaries(), signal });

  static getSpending = ({ currency, date }: DashboardItemsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<Spending[]>>({ url: dashboard.spending(currency), queryParams: { date }, signal });

  static getExpenseCategories = ({ currency, date }: DashboardItemsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<ExpenseCategory[]>>({ url: dashboard.expenseCategories(currency), queryParams: { date }, signal });

  static getMerchants = ({ currency, date }: DashboardItemsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<Merchant[]>>({ url: dashboard.merchants(currency), queryParams: { date }, signal });

  static getPaymentSummary = (request: PaymentSummariesRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<PaymentSummariesResponse>>({ url: dashboard.paymentSummary(), queryParams: request, signal });
}
